export const specTypes = {
  ADD: 'ADD',
  DELETE: 'DELETE',
  FETCH: 'FETCH',
  MUTATION: 'MUTATION',
  PAGINATION: 'PAGINATION',
  REFETCH: 'REFETCH',
};
